import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-feebypass',
  templateUrl: './feebypass.component.html',
  styleUrls: ['./feebypass.component.scss']
})
export class FeebypassComponent implements OnInit {
  FeeDetailForm: FormGroup;
  APIService: string;
  dialogRef: MatDialogRef<any>;
  feeList: any;
  filteredfeeList: any;
  sessionList: any[];
  SessionFilterList: any[];
  FeeData = []
  filteredcourseList: any;
  courseList: any;
  filteredCollegeList: any;
  collegeList: any;
  Table = false;
  TotalFees: any;
  TotalPaid: any;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,    private location: Location,
    private dialog: MatDialog,public router: Router
  ) {
    this.APIService = environment.serviceUrl;
  }

  ngOnInit(): void {
    this.FeeData = []
    this.Table = false;
    this.TotalFees = 0
    this.TotalPaid = 0
    this.FeeDetailForm = this.fb.group({
      FeeType: new FormControl('',Validators.required),
      SnNo: new FormControl('',Validators.required),
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
      FeeStatus: new FormControl('')
    });
    this.fetchFeeType();
    this.fetchSession();
    this.getCollegeData();
    this.getCourseData();
  }

  fetchFeeType() {
    const payload = {};
    payload['CdType'] = 'FT';
    this.umsService.getCodeType(payload).subscribe((res) => {
      if (res.status) {
        this.feeList = res.data;
        this.filteredfeeList = this.feeList.slice();
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  getCollegeData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }

  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredcourseList = this.courseList.slice();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-close'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  getData(){
    if (this.FeeDetailForm.invalid) {
      this.FeeDetailForm.get('FeeType').markAsTouched();
      this.FeeDetailForm.get('SnNo').markAsTouched();
      return;
    } else {
      this.getList()
    }
  }

  getList(){
    this.FeeData = [];
    const payload = {};
    this.Table = false;
    this.TotalFees = 0
    this.TotalPaid = 0
    let submitpayload = this.FeeDetailForm.value
    payload['FeeType'] = submitpayload.FeeType;
    payload['SnNo'] = submitpayload.SnNo;
    payload['StuId'] = 0;
    payload['CgCode'] = submitpayload.CgCode;
    payload['CoCode'] = submitpayload.CoCode;
    payload['FeeStatus'] = submitpayload.FeeStatus
    this.umsService.Feebypass(payload).subscribe((res) => {
      if (res.status) {
        this.FeeData = res.data
        this.Table = true
        this.TotalFees = res.data[0]['TotFeeAmt'];
        this.TotalPaid = res.data[0]['TotPaidAmt'];
      }
      else{
        this.Table = false
        let data = {}
        this.TotalFees = 0
        this.TotalPaid = 0
        data['message'] = 'No Data Found'
        data['title'] = 'Information'
        data['icon'] = 'fas fa-box-open'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      }
    }, (ERROR: HttpErrorResponse) => {
      // this.spinner.hide();
      this.Table = false;
      let data = {}
      data['message'] = ERROR.error.message
      data['title'] = 'Information'
      data['icon'] = 'fas fa-box-open'
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  back(){
    this.ngOnInit();
  }

}

